export type Lang = 'zh-CN' | 'en-US';

/**
 * @description 获取默认语言
 */
export const getLocalLang = () => {
  // 这是获取浏览器的语言
  // const language = (navigator.language || 'en').toLocaleLowerCase();

  const storageLang = window.localStorage.getItem('lang') ?? 'zh-CN';

  if (['zh-CN', 'en-US'].includes(storageLang)) {
    return storageLang as Lang;
  }

  return 'zh-CN';
};

export const setLocalLang = (lang: Lang) => {
  return window.localStorage.setItem('lang', lang);
};

export const getAnotherLang = (lang: Lang): Lang => {
  if (lang === 'zh-CN') return 'en-US';
  if (lang === 'en-US') return 'zh-CN';
  return 'zh-CN';
};
